// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Vaso","buttons":"Footer_buttons__gMJHC"};